export default "__VITE_ASSET__DvThxC1a__"